export default "__VITE_ASSET__CMaW9m6u__"